// Содержимое справки.
//
// Хранится кодом, а не в базе, намеренно: справка меняется вместе с
// продуктом и должна ехать в том же коммите, что и правка, которую она
// описывает. Отдельная админка для редактирования текстов при одном
// авторе — лишняя сущность, а расхождение справки с поведением продукта —
// худшее, что с ней может случиться.
//
// Формат блока:
//   { t: 'p'   , x: 'абзац' }
//   { t: 'ul'  , x: ['пункт', 'пункт'] }
//   { t: 'ol'  , x: ['шаг', 'шаг'] }
//   { t: 'note', x: 'выделенное замечание' }
//   { t: 'warn', x: 'предупреждение' }
//
// Никакого HTML из строк не рендерится — только эти типы, поэтому справку
// нельзя случайно превратить в дыру через вставку разметки.

export const HELP_SECTIONS = [
  { id: 'start', title: 'Начало работы' },
  { id: 'modules', title: 'Разделы программы' },
  { id: 'account', title: 'Доступ и безопасность' },
  { id: 'billing', title: 'Тариф и оплата' },
  { id: 'trouble', title: 'Если что-то не так' },
];

export const HELP_ARTICLES = [
  // ------------------------------------------------------------ начало
  {
    id: 'connect-iiko',
    section: 'start',
    title: 'Как подключить iiko',
    keywords: 'iiko подключение настройка сервер логин пароль интеграция',
    body: [
      { t: 'p', x: 'Пока iiko не подключена, разделы с цифрами (выручка, списания, кухня, касса, чеки, KPI, CRM) не работают — брать данные неоткуда. Подключение занимает пару минут и делается один раз.' },
      { t: 'ol', x: [
        'Откройте «Первые шаги» на дашборде и нажмите «Подключите iiko». Если баннера уже нет, то же окно открывается со страницы настроек.',
        'Адрес сервера — тот же, по которому вы заходите в iikoOffice, вместе с портом. Например: https://ваш-сервер.iiko.it:443',
        'Логин и пароль — отдельной учётной записи iiko, а не вашей личной. Заведите её в iikoOffice с правами на просмотр отчётов: так вы сможете отозвать доступ, не меняя собственный пароль.',
        'API-ключ и идентификатор организации нужны только для работы с базой гостей (раздел CRM). Если их не заполнить, всё остальное работает.',
      ] },
      { t: 'note', x: 'Пароль от iiko хранится в базе в зашифрованном виде и нигде в программе не показывается — ни вам, ни поддержке.' },
      { t: 'p', x: 'Сразу после подключения программа начинает выгружать историю. Первые цифры появляются в течение минуты, полная история за два года подтягивается фоном.' },
    ],
  },
  {
    id: 'no-data-yet',
    section: 'start',
    title: 'Данных нет или написано «Загружаем данные»',
    keywords: 'пусто нули нет данных загружаем ждать долго',
    body: [
      { t: 'p', x: 'Это нормальное состояние в двух случаях: сразу после подключения iiko и первые секунды после перезапуска программы.' },
      { t: 'p', x: 'Программа намеренно показывает «Загружаем данные» вместо нулей. Ноль выручки и «мы ещё не спросили» выглядят на экране одинаково, но означают противоположное, и принимать решения по ложному нулю — хуже, чем подождать десять секунд.' },
      { t: 'p', x: 'Если сообщение висит дольше минуты — скорее всего, недоступен сервер iiko. Смотрите статью «iiko недоступна».' },
    ],
  },
  {
    id: 'roles',
    section: 'start',
    title: 'Роли: кто что видит',
    keywords: 'роли права доступ администратор управляющий сотрудник',
    body: [
      { t: 'p', x: 'В программе три роли внутри заведения.' },
      { t: 'ul', x: [
        'Администратор — видит и меняет всё, включая пользователей, тариф и оплату.',
        'Управляющий — видит рабочие разделы, включая зарплаты и табель, но не управляет пользователями и оплатой.',
        'Сотрудник — рабочие разделы без денег по персоналу: суммы зарплат, авансов и штрафов ему не показываются.',
      ] },
      { t: 'warn', x: 'Раздел «Сотрудники» с суммами оплаты труда доступен только администратору и управляющему. Это разграничение проверяется на сервере, а не только скрытием кнопок в интерфейсе.' },
    ],
  },

  // ------------------------------------------------------------ модули
  {
    id: 'dashboard',
    section: 'modules',
    title: 'Дашборд: выручка и прогноз',
    keywords: 'дашборд главная выручка прогноз график тренд',
    body: [
      { t: 'p', x: 'Дашборд показывает выручку за сегодня, динамику за две недели и прогноз. График обновляется каждые десять минут.' },
      { t: 'p', x: 'Прогноз строится по вашей же истории: программа учитывает день недели и общий тренд. Прогноз на конкретный календарный день не «плавает» в течение дня — он фиксируется, чтобы утреннюю и вечернюю цифру можно было сравнивать между собой.' },
      { t: 'note', x: 'Чем больше истории выгружено, тем точнее прогноз. В первые дни после подключения он основан на коротком ряде и будет заметно грубее.' },
    ],
  },
  {
    id: 'dashboard-layout',
    section: 'modules',
    title: 'Как настроить дашборд под себя',
    keywords: 'дашборд настроить перетащить виджеты порядок скрыть ширина раскладка drag',
    body: [
      { t: 'p', x: 'Кнопка «Настроить» вверху дашборда включает режим настройки. У каждого виджета появляется панель с его названием.' },
      { t: 'ul', x: [
        'Порядок: перетащите виджет за название на новое место. На телефоне — пальцем за название. С клавиатуры: Tab до названия и стрелки вверх/вниз.',
        'Ширина: кнопки ⅓, ½, ⅔ и «Вся ширина». Узкие виджеты встают рядом в одну строку. На телефоне все виджеты во всю ширину.',
        'Лишнее: кнопка с перечёркнутым глазом скрывает виджет. Вернуть его — в блоке «Скрытые виджеты» внизу страницы.',
      ] },
      { t: 'p', x: 'Нажмите «Сохранить». Раскладка своя у каждого сотрудника и хранится на сервере, поэтому одинакова на компьютере и телефоне. У коллег ничего не меняется.' },
      { t: 'note', x: '«Как было» возвращает стандартную раскладку. Новые виджеты, которые появятся в программе, сами встанут на своё место и в настроенном дашборде.' },
    ],
  },
  {
    id: 'period-report',
    section: 'modules',
    title: 'Отчёт о выручке за период',
    keywords: 'отчёт период выручка сравнение прошлый год месяц неделя csv excel выгрузка',
    body: [
      { t: 'p', x: 'На дашборде кнопка «Отчёт за период» открывает отчёт за любой срок до года: неделя, месяц, с начала года или свои даты.' },
      { t: 'ul', x: [
        'Выручка, чеки, средний чек и выручка в среднем за день — с изменением к предыдущему такому же по длине периоду и к тем же датам год назад.',
        'Средняя выручка по дням недели — видно, какие дни тянут неделю, а какие проседают.',
        'Лучший и худший день периода и таблица по дням. Кнопка «Скачать CSV» выгружает её для Excel.',
      ] },
      { t: 'note', x: 'Сравнение показывается только тогда, когда история целиком покрывает период, с которым сравниваем. Если данные из iiko загружены позже, сравнения не будет — это лучше, чем ложные «+180%».' },
      { t: 'p', x: 'Если в период попадает сегодняшний день, в итоги он входит по текущий момент, а в средних и в лучшем/худшем дне не учитывается: день ещё не закончился.' },
    ],
  },
  {
    id: 'month-goal',
    section: 'modules',
    title: 'Цель по выручке на месяц',
    keywords: 'цель план месяц выручка темп нужно в день прогноз',
    body: [
      { t: 'p', x: 'На дашборде есть карточка «Цель месяца». Владелец или управляющий задаёт сумму выручки на текущий месяц — кнопка «Задать цель» в карточке. Остальные сотрудники с доступом к дашборду цель видят, но изменить не могут.' },
      { t: 'ul', x: [
        'Набрано — выручка с 1-го числа, включая сегодняшний день на текущий момент.',
        'Прогноз на конец месяца — фактическая выручка прошедших дней плюс прогноз на сегодня и оставшиеся дни. Засечка на полосе показывает, где по прогнозу окажется месяц.',
        'Нужно в день — сколько в среднем надо зарабатывать в оставшиеся дни, включая сегодня, чтобы выйти на цель.',
      ] },
      { t: 'p', x: 'Если с 5-го числа прогноз месяца ниже 97% цели, Советник покажет совет «Цель месяца под угрозой»: сколько нужно в день и сколько даёт прогноз.' },
      { t: 'note', x: 'Цель прошедшего месяца изменить нельзя — чтобы итог месяца нельзя было «подогнать» задним числом. Чтобы снять цель текущего месяца, сохраните пустое поле.' },
    ],
  },
  {
    id: 'telegram-digest',
    section: 'modules',
    title: 'Утренняя сводка в Telegram',
    keywords: 'telegram телеграм сводка отчёт утро уведомление оповещение бот смена напоминание списания',
    body: [
      { t: 'p', x: 'Каждое утро в выбранный час бот вашего заведения присылает короткую сводку: выручку за вчера в сравнении с прогнозом и тем же днём прошлой недели, чеки и средний чек, темп месяца к цели. По понедельникам в сводке есть итоги прошлой недели, 1-го числа — итоги прошлого месяца.' },
      { t: 'ol', x: [
        'Администратор один раз подключает Telegram-бота организации: «Пользователи» → «Интеграции».',
        'Каждый сотрудник подключает себя сам: «Мой профиль» → «Уведомления» → «Подключить». Откроется бот — нажмите «Старт».',
        'Там же выберите час сводки и включите или выключите дневные оповещения. Кнопка «Прислать сводку сейчас» покажет, как сводка выглядит.',
      ] },
      { t: 'p', x: 'Сводка приходит только тем, кому открыт дашборд, и в ней только то, что роли видно в программе: советы Советника — владельцу и управляющему, стоп-лист — тем, у кого есть «Кухня», списания за вчера и за неделю — тем, у кого есть «Списания», кто сегодня на смене — тем, у кого есть «Сотрудники». Если задана цель месяца, в сводке будет и план на сегодня.' },
      { t: 'p', x: 'Сотрудники, которые заведены в разделе «Сотрудники» и привязаны к своей учётной записи, могут получать напоминание о завтрашней смене — вечером, в 18:00. Для этого не нужен доступ к выручке: привязать Telegram может любой сотрудник.' },
      { t: 'p', x: 'Кроме сводки, бот присылает короткие оповещения (их можно выключить в профиле): после 14:00 — если выручка идёт больше чем на 20% ниже прогноза дня, и в любое время — когда позиция, которая у вас продаётся, встала в стоп-лист. Каждое событие — не больше одного раза в день.' },
      { t: 'note', x: 'В самом боте работают команды /digest — прислать сводку сейчас и /stop — больше не присылать. Включить сводку обратно можно в профиле.' },
    ],
  },
  {
    id: 'writeoffs',
    section: 'modules',
    title: 'Списания',
    keywords: 'списания порча брак расход склад',
    body: [
      { t: 'p', x: 'Раздел показывает списания за выбранный период: что списано, сколько и на какую сумму. Периоды — от «сегодня» до произвольного диапазона дат.' },
      { t: 'p', x: 'Данные берутся из iiko как есть. Если списание не проведено в iiko, в программе его не будет — она ничего не досчитывает за вас.' },
    ],
  },
  {
    id: 'kitchen-foodcost',
    section: 'modules',
    title: 'Кухня и фудкост',
    keywords: 'кухня фудкост себестоимость наценка группы блюд бар товары',
    body: [
      { t: 'p', x: 'Раздел считает фудкост — долю себестоимости в выручке — и показывает блюда с подозрительной себестоимостью.' },
      { t: 'p', x: 'Каждая группа блюд из iiko относится к одному из четырёх типов: кухня, бар, товары, услуги. Программа расставляет типы автоматически по номенклатурной категории и названию группы, а вы можете поправить любую вручную — ручная настройка всегда важнее догадки.' },
      { t: 'warn', x: 'В процент фудкоста попадают только кухня и бар. Товары (покупное, сигареты, сувениры) и услуги считаются отдельно и в процент не входят — иначе перепродажа с наценкой искажала бы картину по еде.' },
      { t: 'note', x: 'Если фудкост выглядит странно, начните с проверки типов групп: одна крупная группа, ошибочно отнесённая к кухне, сдвигает весь процент.' },
    ],
  },
  {
    id: 'employees',
    section: 'modules',
    title: 'Сотрудники: справочник, расписание, табель',
    keywords: 'сотрудники персонал табель расписание смены должности приём увольнение',
    body: [
      { t: 'p', x: 'Раздел заменяет таблицу в Excel: справочник сотрудников с должностями и условиями оплаты, расписание смен, табель по дням и отсутствия.' },
      { t: 'ol', x: [
        'Заведите должности — они задают условия оплаты по умолчанию.',
        'Добавьте сотрудников вручную или импортируйте справочник из iiko.',
        'Составьте расписание на месяц. Из расписания можно перенести смены в табель, чтобы не вводить дни дважды.',
        'В табеле правьте фактические часы и отмечайте отсутствия.',
      ] },
      { t: 'p', x: 'План и факт сравниваются в сводке: видно, где смен отработано больше или меньше запланированного.' },
    ],
  },
  {
    id: 'payroll',
    section: 'modules',
    title: 'Расчётный листок и выгрузка',
    keywords: 'зарплата расчёт листок аванс премия штраф выгрузка excel',
    body: [
      { t: 'p', x: 'По закрытому периоду формируется расчётный листок на каждого сотрудника: отработанные часы, ставка, авансы, премии, удержания и итог.' },
      { t: 'p', x: 'Итог считается автоматически, но его можно переопределить вручную — тогда рядом сохраняется отметка, что сумма проставлена руками, и кем.' },
      { t: 'note', x: 'Любая правка в табеле пишется в журнал: видно, кто и когда менял значение. Это не слежка, а способ ответить на вопрос «почему у меня в листке другая цифра».' },
    ],
  },
  {
    id: 'kpi',
    section: 'modules',
    title: 'KPI сотрудников',
    keywords: 'kpi показатели премия оценка критерии официанты',
    body: [
      { t: 'p', x: 'Раздел считает показатели работы сотрудников по критериям, которые вы задаёте сами: набор критериев и их вес настраиваются под каждую должность.' },
      { t: 'p', x: 'История расчётов сохраняется, поэтому можно сравнить месяцы между собой и показать сотруднику, из чего сложилась оценка.' },
      { t: 'warn', x: 'Раздел доступен не на всех тарифах. Если он закрыт, программа предложит перейти на подходящий тариф.' },
    ],
  },
  {
    id: 'crm',
    section: 'modules',
    title: 'CRM: гости, теги, задачи, промоакции',
    keywords: 'crm гости лояльность база клиентов теги задачи сегменты промоакции',
    body: [
      { t: 'p', x: 'CRM работает поверх базы гостей из вашей системы лояльности iiko. Программа не заводит гостей сама — она показывает тех, кто уже есть в iiko, и позволяет с ними работать: помечать тегами, ставить задачи, собирать сегменты, вести заметки.' },
      { t: 'p', x: 'Гостя можно найти по номеру телефона. В карточке видны посещения, суммы и история работы с ним.' },
      { t: 'p', x: 'Промоакции начисляют бонусы выбранному сегменту гостей прямо в iiko. Перед запуском показывается предпросмотр: сколько гостей попадёт под условия.' },
      { t: 'warn', x: 'Для CRM нужны API-ключ и идентификатор организации в настройках iiko — без них база гостей недоступна. Раздел также доступен не на всех тарифах.' },
    ],
  },
  {
    id: 'cash-receipts',
    section: 'modules',
    title: 'Касса и чеки',
    keywords: 'касса смены чеки закрытые заказы официант стол оплата',
    body: [
      { t: 'p', x: '«Касса» показывает открытые смены и текущую выручку по ним. «Чеки» — закрытые чеки за день: состав заказа, сумма, стол, официант, тип оплаты.' },
      { t: 'note', x: 'iiko не отдаёт готовые объекты чеков, поэтому чек собирается из построчной выгрузки продаж. Если в чеке что-то выглядит не так, сверьтесь с отчётом продаж в iikoOffice за тот же день — расхождение будет означать проблему на стороне выгрузки, и об этом стоит написать в поддержку.' },
    ],
  },
  {
    id: 'purchases',
    section: 'modules',
    title: 'Закупки',
    keywords: 'закупки заявки согласование покупка утверждение',
    body: [
      { t: 'p', x: 'Сотрудник создаёт заявку на закупку, ответственный согласовывает или отклоняет её. Стоимость считается на сервере из цены и количества — подставить произвольную сумму из браузера нельзя.' },
      { t: 'p', x: 'У каждой заявки есть история: кто создал, кто согласовал, когда куплено. Отклонённую заявку можно доработать и отправить повторно.' },
    ],
  },
  {
    id: 'chat',
    section: 'modules',
    title: 'Чат',
    keywords: 'чат сообщения переписка вложения уведомления',
    body: [
      { t: 'p', x: 'Внутренний чат для сотрудников заведения: личные и групповые переписки, вложения, отметки о прочтении, статус «в сети».' },
      { t: 'p', x: 'Переписка видна только участникам конкретного чата и не покидает вашу организацию.' },
    ],
  },

  // ------------------------------------------------------------ доступ
  {
    id: 'two-factor',
    section: 'account',
    title: 'Двухфакторная аутентификация',
    keywords: '2fa двухфакторная код аутентификатор google authenticator резервные коды безопасность',
    body: [
      { t: 'p', x: 'Второй фактор — код из приложения-аутентификатора, который меняется каждые 30 секунд. Включается в профиле, на вкладке «Безопасность».' },
      { t: 'ol', x: [
        'Нажмите «Включить» и подтвердите свой пароль.',
        'Отсканируйте QR-код приложением: Google Authenticator, Яндекс Ключ, 1Password и любое другое.',
        'Введите код из приложения — до этого момента защита не включается, поэтому ошибка при сканировании не запрёт вас снаружи.',
        'Сохраните резервные коды.',
      ] },
      { t: 'warn', x: 'Резервные коды показываются один раз. Каждый работает однократно и нужен, если телефон потеряется. В базе хранятся только их отпечатки — восстановить коды не сможет никто, включая нас.' },
      { t: 'p', x: 'Вводить резервный код можно как удобно: строчными буквами и без дефисов — программа приведёт его к нужному виду сама.' },
      { t: 'note', x: 'Если код не подходит, проверьте время на телефоне. Расхождение часов — самая частая причина: программа допускает разницу в полминуты, но не больше.' },
    ],
  },
  {
    id: 'password-reset',
    section: 'account',
    title: 'Забыли пароль',
    keywords: 'пароль забыл восстановление сброс письмо ссылка',
    body: [
      { t: 'p', x: 'На странице входа нажмите «Забыли пароль?» и укажите свой логин или почту. Если такая учётная запись есть и у неё указан адрес, на него придёт ссылка.' },
      { t: 'p', x: 'Ссылка действует час и срабатывает один раз. Новая заявка отменяет предыдущую ссылку.' },
      { t: 'note', x: 'Ответ программы одинаков и для существующего логина, и для несуществующего. Так сделано специально: иначе форму можно было бы использовать для проверки, кто у вас работает.' },
      { t: 'warn', x: 'Письмо придёт только после того, как в программе настроена почта. Если письма нет и вы уверены, что адрес указан верно, напишите в поддержку — пароль поменяют вручную.' },
    ],
  },
  {
    id: 'users-limit',
    section: 'account',
    title: 'Пользователи и ограничение по тарифу',
    keywords: 'пользователи добавить сотрудника лимит тариф места',
    body: [
      { t: 'p', x: 'Учётные записи для входа заводит администратор в разделе «Пользователи». Это не то же самое, что справочник сотрудников: доступ в программу нужен не всем, кто числится в табеле.' },
      { t: 'p', x: 'На тарифах с ограничением по числу пользователей программа не даст завести лишнего и предложит перейти на тариф выше.' },
    ],
  },

  // ------------------------------------------------------------ оплата
  {
    id: 'trial-and-plans',
    section: 'billing',
    title: 'Пробный период и тарифы',
    keywords: 'тариф оплата пробный период триал подписка счёт',
    body: [
      { t: 'p', x: 'Новая организация получает пробный период на 7 дней со всеми разделами. Дата окончания видна на странице входа и в разделе «Биллинг».' },
      { t: 'p', x: 'После оплаты подписка продлевается автоматически в ту же дату следующего периода. Карта сохраняется при первой оплате.' },
      { t: 'p', x: 'Отменить продление можно самостоятельно в «Биллинге»: доступ сохранится до конца уже оплаченного периода.' },
      { t: 'note', x: 'Для оплаты по безналу в «Биллинге» формируется счёт с вашими реквизитами.' },
    ],
  },
  {
    id: 'payment-failed',
    section: 'billing',
    title: 'Оплата не прошла',
    keywords: 'оплата не прошла карта списание ошибка блокировка доступ',
    body: [
      { t: 'p', x: 'Если очередное списание не прошло, доступ сразу не закрывается. Программа повторит попытку через два дня, и так до трёх раз.' },
      { t: 'p', x: 'О каждой неудачной попытке приходит письмо. Доступ приостанавливается только после третьей.' },
      { t: 'warn', x: 'Приостановка не удаляет данные. Кассы, гости, сотрудники и переписка сохраняются: после возобновления подписки всё на месте, настраивать заново ничего не нужно.' },
    ],
  },

  // ------------------------------------------------------------ проблемы
  {
    id: 'iiko-down',
    section: 'trouble',
    title: 'iiko недоступна',
    keywords: 'ошибка недоступна сервер не отвечает 503 не грузится',
    body: [
      { t: 'p', x: 'Сообщение «iiko недоступна» означает ровно то, что написано: наша программа работает, а сервер iiko не ответил. Данные при этом не теряются — они лежат в iiko и подтянутся, когда связь восстановится.' },
      { t: 'ul', x: [
        'Проверьте, открывается ли iikoOffice с того же компьютера.',
        'Убедитесь, что сервер iiko включён и не идёт его обновление.',
        'Если iikoOffice работает, а у нас ошибка — напишите в поддержку, приложив время, когда это было.',
      ] },
      { t: 'note', x: 'Пока связи нет, разделы показывают ошибку, а не старые цифры под видом свежих. Это осознанно: устаревшая выручка на экране опаснее честной ошибки.' },
    ],
  },
  {
    id: 'support',
    section: 'trouble',
    title: 'Как написать в поддержку',
    keywords: 'поддержка обращение тикет помощь связаться',
    body: [
      { t: 'p', x: 'Раздел «Поддержка» — обращения внутри программы. Укажите тему, опишите проблему, при необходимости приложите файл или скриншот.' },
      { t: 'p', x: 'Категория помогает быстрее направить обращение: техническая проблема, вопрос по оплате, общий вопрос или прочее. Приоритет ставьте честно — «срочно» на всём подряд перестаёт работать.' },
      { t: 'p', x: 'Ответ приходит в то же обращение, история переписки сохраняется.' },
      { t: 'note', x: 'Полезно приложить: что делали, что ожидали увидеть, что увидели, и во сколько это было. По времени мы находим нужные записи в журнале.' },
    ],
  },
];
